import { FetchResult, gql } from 'apollo-boost';
import { INarrative } from '../../../models/narrative';
import { MultiError } from '../../../types/multi-error';
import { graphqlClient } from '../../graphql-client';

const MUTATION = gql`
    mutation NarrativeSave($narrative: NarrativeInput!, $imageFile: Upload, $emailImageFile: Upload, $signatureFile: Upload, $catalogFile: Upload, $soundtrackFile: Upload){
        narrative_save (narrative_data: $narrative, imageFile: $imageFile, emailImageFile: $emailImageFile, signatureFile: $signatureFile, catalogFile: $catalogFile, soundtrackFile: $soundtrackFile) {
            uid
        }
    }
`;

export async function narrativeSave(narrative: Partial<INarrative>, imageFile?: File, emailImageFile?: File, signatureFile?: File, catalogFile?: File, soundtrackFile?: File): Promise<string> {
    const result: FetchResult<{ narrative_save: { uid: string }}> = await graphqlClient.mutate({
        mutation: MUTATION,
        variables: { narrative: {
            uid: narrative.uid,
            title: narrative.title,
            min_age_rating: narrative.minAgeRating,
            rating_label: narrative.ratingLabel,
            description: narrative.description,
            external_image_url: narrative.externalImageUrl,
            content_url: narrative.contentUrl,
            media_type: narrative.mediaType,
            platform_type: narrative.platformType,
            platforms: narrative.platforms,
            file_name: narrative.fileName,
            email_image_file_name: narrative.emailImageFileName,
            coming_soon: narrative.comingSoon,
            ip_licensed: narrative.ipLicensed,
            ignore_ip_licensing: narrative.ignoreIPLicensing,
            status: narrative.status,
            duration: narrative.duration,
            end_survey: narrative.endSurveyUid,
            ip_holder_uid: narrative.ipHolder?.uid,
        }, imageFile, emailImageFile, signatureFile, catalogFile, soundtrackFile },
        errorPolicy: 'all',
    });

    if(!result.data || result.errors && result.errors.length) {
        throw new MultiError(result.errors || ['Unknown error']);
    }

    return result.data.narrative_save.uid;
}
